(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mx-storefront"] && !Shopify.designMode) return;
  try {
    
(() => {const root=document.querySelector('.mx-clean');if(!root)return;const cards=[...root.querySelectorAll('.mx-clean-card')];const select=root.querySelector('[data-mx-color]');function filter(){const kind=root.querySelector('[data-mx-type][aria-pressed="true"]').dataset.mxType;const color=select.value;let shown=0;cards.forEach(card=>{const visible=(kind==='all'||card.dataset.kind===kind)&&(color==='all'||card.dataset.color===color);card.hidden=!visible;if(visible)shown++;});root.querySelector('.mx-clean-empty').hidden=shown>0;}root.querySelectorAll('[data-mx-type]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-mx-type]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));filter();}));select.addEventListener('change',filter);filter();})();

  } catch(e) { console.error(e); }
})();
})();
